/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "Wo5dMEP_BbI",
    title: "Katrina Kaif's Everyday Makeup Look  | The Classic Kay Look | Kay Beauty | Nykaa",
    description:
      "Bollywood Star Katrina Kaif is bound to be a perfect 10/10 even with minimum makeup. She is famous for carrying simple nude makeup looks like no one else giving everybody major makeup goals.At this time when most of us are at home practicing social distancing, we need a simple nude makeup look that is apt for video calls, basic outings, etc.In this video, Katrina Kaif will show the classic Kay Look that will look good with any outfit using products from her makeup line - Kay Beauty.Katrina's everyday makeup look is super easy to create and will surely make you look stunning!",
    category: "Makeup",
    videoId: "nsOD3p2PfZk",
    uploaded: new Date(2020, 7, 3)

  },
  {
    _id: "Wo5gggyyyy",
    title: "Get Ready With Janhvi Kapoor | Glam Smokey Eye Tutoria |  Smudged-On-Purpose Makeup",
    description:
      "Smokey eyes continue to be one of the hottest trends in the beauty and makeup world and it doesn't seem like this sultry eye look is going anywhere anytime soon. Most of us have to admit that we find this eye look truly intimidating to do on our own",
    category: "Makeup",
    videoId: "lQ_b1uiGQeA",
    uploaded: new Date(2020, 7, 3)

  },
  {
    _id: "ghytffjukkkk",
    title: "Alaya F On The Best Makeup Hacks That Bollywood Has Taught Her | Vogue Beauty Festival 2021",
    description:
      "What is the best way to apply concealer to lift and brighten your face? How can you make your eyelashes stay curled for longer? Alaya F teaches you the tricks of the trade that she’s learnt from her makeup artists on set",
    category: "Makeup",
    videoId: "VwW9G6nLDzo",
    uploaded: new Date(2020, 7, 3)

  },
  {
    _id: "tthhhuufff",
    title: "GRWM: Get Ready With Janhvi Kapoor | Brunch Makeup Look | Janhvi's Easy Daytime Look | Nykaa",
    description:
      "If you’re an avid bruncher, you know that the act of going to brunch is more than just a special occasion – it’s a lifestyle, and it’s a time to make a statement with how you look from head to toe. The key to a beautiful brunch beauty look is about creating effortless looking, sun-kissed glow! Actress Janhvi Kapoor shows us a fresh-faced, minimal makeup look because it’s simple, quick and pretty without looking overdone.",
    category: "Makeup",
    videoId: "CD8PP8SHMPM",
    uploaded: new Date(2019, 7, 3)

  },
  {
    _id: "jjjttgggb",
    title: "Your exclusive guide to the stunning Ashes of Roses look | The Body Shop Masterclass",
    description:
      "Be it for the day or a night out, the Ashes of Roses look is perfect for any occasion. Catch expert tips to recreate this look for your special date!  ",
    category: "Makeup",
    videoId: "KFO0PLtveAE",
    uploaded: new Date(2018, 7, 13)

  },
  {
    _id: "jrrfffyffff",
    title: "GRWM: Kiara Advani's Everyday Makeup Look | Get Ready With Kiara Advani  | Pinkvilla",
    description:
      "The stunning Kiara Advani, the heroine of the hit film M.S Dhoni: The Untold Story, chatted with Pinkvilla, and shared some exclusive beauty tips and tricks with us.  ",
    category: "Makeup",
    videoId: "ctp0tv_05QY",
    uploaded: new Date(2017, 5, 30)

  },
  {
    _id: "fhsdjfhofijoj",
    title: "Lakmé Absolute Glam Makeup Look Tutorial Ft. Namrata Soni & Ananya Panday",
    description:
      "Get inspired and get glam! Lakmé presents Masterclass with ace makeup artist Namrata Soni and dazzling Ananya Panday! Learn how to get the fresh off the runway look",
    category: "Makeup MasterClass",
    videoId: "8OSrXLU-5wo",
    uploaded: new Date(2022, 4, 13)

  },
  {
    _id: "hbfkjdsnfksd",
    title: "LAKMÉ MAKE-UP MASTER CLASS BY NAMRATA SONI #SPOTLIGHTREADY | LAKMÉ FASHION WEEK 2020",
    description:
      "Watch the live stream of Lakme Master-Class by Namrata Soni #SpotlightReady at Lakmé Fashion Week 2020",
    category: "Makeup MasterClass",
    videoId: "J-0YtN-wtR0",
    uploaded: new Date(2022, 4, 10)

  },
  {
    _id: "jjyygggtt",
    title: "Madhuri Dixit’s Skincare Routine | Madhuri Dixit Nene",
    description:
      "Hi guys, I’m back with one of my most requested videos! Today’s video is all about my Skincare tips and tricks, I hope this video helps you, let me know in the comments below if it did! Don’t forget to like, share and subscribe to my channel and I’ll see you in my next video :)  ",
    category: "Skincare",
    videoId: "0JHQut_Lwgw",
    uploaded: new Date(2017, 9, 13)

  },
  {
    _id: "jhhyyrrr",
    title: "Divya Khosla Kumar reveals her skincare routine secrets | Skin Care Tips | Fashion | Pinkvilla",
    description:
      "From how to prevent ageing, to how to pamper your skin, Divya Khosla Kumar demonstrates it all. Watch on to get a glimpse of Divya Khosla Kumar's skin care favourites and her DIY skin care home remedies.  ",
    category: "Skincare",
    videoId: "4CzDB_-mMfw",
    uploaded: new Date(2016, 9, 13)

  },
  {
    _id: "jhttthyyrrr",
    title: "Nidhhi Agerwal reveals her skin care routine secrets | Home Remedies",
    description:
      "For those of you on a budget, Nidhhi gave some DIY-tried and tested home remedies.Watch this video to see what Nidhhi Agerwal give us an insight into it all!  ",
    category: "Skincare",
    videoId: "JzpGkx-n_yc",
    uploaded: new Date(2017, 9, 13)

  },
  {
    _id: "hhyyttfff",
    title: "How to Style With Celebrity Stylist Emma Jade Morrison",
    description:
      "Watch as celebrity stylist, Emma Jade Morison, who works with Emily Ratajkowski, Rosie Huntington-Whiteley, Lily Aldrige, and Martha Hunt walks us through her top 3 looks to wear on a weekend getaway. ",
    category: "Fashion",
    videoId: "Z6Fu2Pyswb8",
    uploaded: new Date(2022, 3,10 )

  },
  {
    _id: "hhyyttfuuuff",
    title: "Manish Malhotra Shares His Bollywood Style Secrets ",
    description:
      "Watch Manish Malhotra in the latest Vogue All Access episode! If there's one thing Manish Malhotra is known for, it's his love for 'Bollywood glamour'.",
    category: "Fashion",
    videoId: "jCdGHk1RJ68",
    uploaded: new Date(2022, 4, 14)

  },
  {
    _id: "geehggggfff",
    title: "Priyanka Chopra's Guide to Fashion | Little Black Book",
    description:
      "Priyanka Chopra may have good genetics and natural beauty on her side—but she puts her trust in her expert stylists to help her choose the looks that are garnering her an ever growing base of fashion fans.",
    category: "Fashion",
    videoId: "U_czrFOpC80",
    uploaded: new Date(2021, 13, 8)

  },
  {
    _id: "gettyyhhhf",
    title: "Saiyami Kher reveals her hair care routine secrets | Curly hair ",
    description:
      "Saiyami Kher is known for her curly locks. Hence, we at Pinkvilla got this curly locks beauty to reveal her secret about how she takes care of her curly hair. From diffusers to the right serum and not combing your hair, watch on for all her tips.",
    category: "Haircare",
    videoId: "eSLw3rkEnBI",
    uploaded: new Date(2017, 13, 7)

  },
  {
    _id: "geiitkkkkkkhf",
    title: "Taapsee Pannu on how to maintain curly hair",
    description:
      "Curly hair is like a newborn: it demands a lot of attention, love and care. It took actor Taapsee Pannu years, but she has finally found the perfect formula to tame those enviable curls: embrace hair oil, use masks and fall in love with deep conditioning. Share your tips on how to maintain curly hair in the comments below. ",
    category: "Haircare",
    videoId: "_X2xPrdfcK4",
    uploaded: new Date(2019, 12, 9)

  },
  {
    _id: "gguuhhjjkkhf",
    title: "How To Wash, Style & Maintain Curly Hair | Heatless Curls",
    description:
      "You don't need to struggle with your CURLY HAIR anymore! Here are a few easy tips on how to WASH, STYLE & MAINTAIN it",
    category: "Haircare",
    videoId: "TjNxipA52sg",
    uploaded: new Date(2020, 3, 13)

  },
  {
    _id: "gdrfghjjkkhf",
    title: "5 Hair Styling Tools That Every Girl Needs To Own!",
    description:
      "Here are some super easy to use yet affordable & efficient HAIR STYLING TOOLS that should be staples in your dressers if you want to achieve ANY hairdo may it be super sleek STRAIGHT hair to CURLY waves and everything in between!",
    category: "Haircare",
    videoId: "q1YgxZdjoWQ",
    uploaded: new Date(2020, 7, 10)

  },
  {
    _id: "gyyhhuuuuiii",
    title: "Voluminous Hair Tutorial",
    description:
      "Here are some super easy  methods to get volumnious hair",
    category: "Haircare",
    videoId: "UV2LeVOLVG4",
    uploaded: new Date(2020, 7, 10)

  },
];
